// 文件分割符
export const FILESEPARATOR = ';file;';
